import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { consumeAuthReturnPath } from '@/shared/lib/auth-redirect'
import { ProductFooter } from '@/shared/ui/product-shell/ProductFooter'
import { useAuthStore } from '@/stores/auth-store'

import '@/shared/ui/product-shell/legacy-product.css'

export function CasdoorCallbackPage() {
  const [error, setError] = useState('')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const processed = useRef(false)

  useEffect(() => {
    if (processed.current) return
    processed.current = true

    const code = searchParams.get('code')
    const state = searchParams.get('state')
    if (!code || !state) {
      setError('登录回调参数缺失，请重新登录')
      return
    }

    useAuthStore
      .getState()
      .loginWithCasdoor(code, state)
      .then(() => {
        navigate(consumeAuthReturnPath(), { replace: true })
      })
      .catch((reason) => {
        setError(reason instanceof Error ? reason.message : '登录失败，请重试')
      })
  }, [searchParams, navigate])

  if (error) {
    return (
      <div className="legacy-product-page legacy-auth-page">
        <main className="grid min-h-screen place-items-center p-4">
          <div className="text-center">
            <p className="mb-4 text-destructive">{error}</p>
            <a href="/login" className="text-sm text-primary underline">
              返回登录页
            </a>
          </div>
        </main>
        <ProductFooter />
      </div>
    )
  }

  return (
    <div className="legacy-product-page legacy-auth-page">
      <main className="grid min-h-[50vh] place-items-center text-muted-foreground">
        正在登录…
      </main>
      <ProductFooter />
    </div>
  )
}
